// Descriptive alt text when set (cleared automatically when the photo changes), else the plant name.
export const plantAlt = (p) => p?.image_alt || p?.name_de || "";

export function PhotoCredit({ credit, className = "" }) {
  if (!credit?.author) return null;
  const src = credit.provider === "pexels" ? "Pexels" : "Wikimedia Commons";
  return (
    <a href={credit.source_url} target="_blank" rel="noopener noreferrer" className={`text-[10px] hover:underline ${className}`} data-testid="plant-photo-credit">
      Foto: {credit.author} · {credit.license ? `${credit.license} · ` : ""}{src}
    </a>
  );
}

export function PlantBadge({ category }) {
  if (category === "toxic") {
    return <span className="badge badge-toxic" data-testid="badge-toxic"><i className="fa-solid fa-skull-crossbones text-[10px]" /> Giftig</span>;
  }
  if (category === "medicinal") {
    return <span className="badge badge-medicinal" data-testid="badge-medicinal"><i className="fa-solid fa-leaf text-[10px]" /> Heilkraut</span>;
  }
  if (category === "tree") {
    return <span className="badge" data-testid="badge-tree" style={{ background: "rgba(101,67,33,0.12)", color: "#654321" }}><i className="fa-solid fa-tree text-[10px]" /> Baum</span>;
  }
  if (category === "invasive") {
    return <span className="badge" data-testid="badge-invasive" style={{ background: "rgba(176,96,32,0.14)", color: "#8B4A12" }}><i className="fa-solid fa-triangle-exclamation text-[10px]" /> Invasiv</span>;
  }
  if (category === "shrub") {
    return <span className="badge" data-testid="badge-shrub" style={{ background: "rgba(85,107,47,0.15)", color: "#556B2F" }}><i className="fa-solid fa-seedling text-[10px]" /> Strauch</span>;
  }
  return <span className="badge badge-edible" data-testid="badge-edible"><i className="fa-solid fa-utensils text-[10px]" /> Essbar</span>;
}

export function Section({ children, className = "", id }) {
  return (
    <section id={id} className={`py-16 md:py-24 ${className}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12">{children}</div>
    </section>
  );
}

export function Heading({ overline, title, subtitle, center = false, light = false }) {
  return (
    <div className={`${center ? "text-center mx-auto max-w-3xl" : "max-w-3xl"} mb-12`}>
      {overline && <div className="overline mb-3">{overline}</div>}
      <h2 className={`font-display text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight ${light ? "text-[var(--wp-cream)]" : "text-[var(--wp-text)]"}`}>{title}</h2>
      {subtitle && <p className={`mt-4 text-base md:text-lg leading-relaxed ${light ? "text-[var(--wp-cream)]/85" : "text-[var(--wp-text-muted)]"}`}>{subtitle}</p>}
    </div>
  );
}

export function Spinner({ label = "Lädt…" }) {
  return (
    <div className="flex items-center gap-3 py-12 justify-center text-sm" style={{ color: "var(--wp-text-muted)" }} data-testid="spinner">
      <span className="inline-block w-4 h-4 rounded-full border-2 border-[var(--wp-primary)] border-t-transparent animate-spin" /> {label}
    </div>
  );
}

export function EmptyState({ icon = "🌱", title, description, children }) {
  return (
    <div className="text-center py-20 px-6">
      <div className="text-5xl mb-4">{icon}</div>
      <h3 className="font-display text-2xl mb-2">{title}</h3>
      {description && <p className="text-sm opacity-70 max-w-md mx-auto">{description}</p>}
      {children && <div className="mt-6">{children}</div>}
    </div>
  );
}
